<template>
    <div class="container-fluid w-100 h-100" style="overflow-x: hidden">
        <navbar :title="$t('menu.traffic_signs')"/>
        <div class="col-sm-12 my-2">
            <road-sign-search
                :user="user"
                @search="fetchRoadSign"
            />
            <div class="col-sm-12">
              <div
                v-if="results.length > 0"
                class="button-container col-sm-12 trip-buttons"
              >
              <button
                  :disabled="!selectedItems || selectedItems.length < 1"
                  class="btn btn-sm btn-primary form-button"
                  @click="showBulkEditor"
              >
                      {{ $t('road_sign.edit_multiple') }}
              </button>

                  <button
                      :disabled="results.length < 1 || loading"
                      class="btn btn-sm btn-outline-primary form-button"
                      @click="showDetailsReport = true"
                  >
                      {{ $t('observations.details_report') }}
                  </button>

                  <button
                      :disabled="results.length < 1"
                      class="form-button btn btn-sm btn-outline-success"
                      @click="exportExcel"
                    >
                      {{ $t('trip.download_excel') }}
                  </button>

                  <button
                      :disabled="loading"
                      class="btn btn-sm btn-primary form-button"
                      @click="toggleMapView"
                  >
                      {{ toggleMapViewLabel }}
                  </button>
              </div>
            </div>
            <!-- Map and results -->
            <div class="trip-results" v-show="results.length > 0">
                <div class="row">
                    <!-- Sign list -->
                    <div :class="{'col-md-6': mapVisible, 'col-12': !mapVisible}" class="mb-2">
                            <Transition name="fade">
                                <road-sign-list
                                    ref="signList"
                                    :road-signs="results"
                                    @row-clicked="editRoadSign"
                                    @row-select="rowSelectionChanged"
                                />
                            </Transition>
                    </div>
                    <div v-if="mapVisible" class="col-md-6 d-flex flex-column nopads pb-0 mb-2">
                        <Transition name="fade">
                            <div class="flex-fill position-relative" style="border-radius: .75em; border: 1px solid #BCBCBC; overflow: hidden">
                                <div class="map-container mr-3 ml-3 mb-2" style="height: 35em; border-radius: .75em; border: 1px solid #BCBCBC; position: relative" >
                                    <map-container
                                        :find-user="false"
                                        ref="mapContainer"
                                        @on-marker-tap="onMarkerTap"
                                        @on-map-changed="mapChanged"
                                    />
                                    <road-sign-map
                                        v-if="map"
                                        ref="signMap"
                                        :map="map"
                                        :signs="mapItems"/>
                                </div>
                            </div>
                        </Transition>
                    </div>
                </div>
            </div>
        </div>

      <road-sign-wizard
        v-if=" roadSign != null"
        :road-sign="roadSign"
        :user="user"
        @close="roadSign=null"
        @close-and-update="closeAndUpdate"
      />

        <road-sign-bulk-editor-dialog
            v-if="bulkEditMode"
            :road-signs="selectedItems"
            :user="user"
            @closeForm="bulkEditMode = false"
            @closeAndUpdate="closeAndUpdate"
        />

        <road-sign-details-report
            v-if="showDetailsReport && results.length > 0"
            :report-signs = "mapItems"
            :user="user"
            :situation-date-text="reportDate"
            @close="showDetailsReport = false"
        />
        <div
        v-if="loading"
        id="loader"
        class="spinner"
      />
  </div>
</template>


<script>
import {restApi} from '../mixins/RestApiMixin'
import RoadSignSearch from "@/components/roadsign/RoadSignSearch";
import RoadSignList from "@/components/roadsign/RoadSignList";
import RoadSignWizard from "@/components/roadsign/RoadSignWizard";
import {downloadHelper} from "../mixins/DownloadMixin";
import Navbar from "@/components/utils/Navbar";
import {inject} from "vue";
import MapContainer from "../map/MapContainer.vue";
import RoadSignMap from "./RoadSignMap.vue";
import RoadSignBulkEditorDialog from "./RoadSignBulkEditorDialog.vue";
import RoadSignDetailsReport from "./RoadSignDetailsReport.vue";
import {timeUtils} from "../mixins/TimeUtils.js";

export default {
    name: 'RoadSigns',
    components: {
        RoadSignDetailsReport,
        RoadSignBulkEditorDialog,
        RoadSignMap, MapContainer, Navbar, RoadSignWizard, RoadSignList, RoadSignSearch},
    mixins: [restApi, downloadHelper, timeUtils],
    props: {
        user: {
            type: Object,
            default: null
        }
    },
    setup() {
        // Inject parents alerter
        const showAlert = inject('showAlert');
        return { showAlert };
    },
    data: function () {
        return {
            results: [],
            mapVisible: false,
            roadSign: null,
            loading: false,
            map: null,
            lastSearchedParams: null,
            toggleMapViewLabel: this.$t('trip.show_map'),
            bulkEditMode: false,
            selectedItems: [],
            showDetailsReport: false,
            reportDate: null
        }
    },

    computed: {
        mapItems() {
            if (this.selectedItems && this.selectedItems.length > 0){
                return this.selectedItems
            }
            return this.results
        }
    },

    methods: {
        showBulkEditor() {
            this.bulkEditMode = true
        },

        mapChanged(map) {
            this.map = map
        },

        selectedSigns() {
            return this.$refs.signList.getSelection()
        },

        doFetchRoadSign: function (params) {
            this.loading = true
            this.lastSearchedParams = params
            if (params && params.in_use_time) {
                let dateStr = params.in_use_time
                dateStr = dateStr.replaceAll('Z', '')
                this.reportDate = this.getDateString(dateStr)
            } else {
                this.reportDate = null
            }
            this.restFetchParams(this.roadSignUrl, this.lastSearchedParams, this.handleSearch, () => {
                this.results = []
                this.loading = false
            })
        },

        fetchRoadSign: function (params) {
            this.$refs.signMap?.initZoomToGroup()
            this.$refs.signList?.resetSelectedRows()
            this.selectedItems = []
            this.doFetchRoadSign(params)
        },

        handleSearch: function (response) {
            this.results = response.data
            this.loading = false
        },
        editRoadSign: function (roadSign) {
            this.roadSign = this.results.find(item => item.id === roadSign?.id)
        },
        rowSelectionChanged(selection) {
            this.$refs.signMap?.initZoomToGroup()
            this.selectedItems = selection
        },
        closeAndUpdate: function () {
            this.roadSign = null
            this.bulkEditMode = false
            this.doFetchRoadSign(this.lastSearchedParams)
        },
        exportExcel: function () {
            this.loading = true
            let params = this.getCommonReportParams(this.lastSearchedParams)
            if (this.selectedItems.length > 0) {
                params.ids = this.selectedItems.map(item => item.id)
            }
            this.restGetDownloadFile(this.roadSignXlsxUrl, params, this.excelDownloadSuccess, this.fileDownloadFail)
        },

        excelDownloadSuccess: function (response) {
            this.loading = false
            this.downloadFile(response, this.$t('signs.report_file_name'))
        },

        fileDownloadFail: function () {
            this.loading = false
            this.showAlert(this.$t('common.report_generation_failed'))
        },

        toggleMapView: function () {
            this.mapVisible = !this.mapVisible
            if (!this.mapVisible) {
                this.map = null
            }
            this.showSelectionEditor = true
        },
        onMarkerTap: function (data) {
            this.selectedIndex = this.results.findIndex(item => item.id === data.id)
            this.$refs.signList.setSelection(this.selectedIndex)
            this.$refs.signList.scrollToSelected()
        },

    }
}
</script>
